import { z } from 'zod';
import { GradeLevel, SchoolDivision } from '@triedge/domain-core/types';

export { GradeLevel, SchoolDivision };

export const FamilyStatusSchema = z.enum(['active', 'inactive', 'archived']);
export type FamilyStatus = z.infer<typeof FamilyStatusSchema>;

export const FamilyWorkflowStatusSchema = z.enum([
  'applied',
  'in-progress',
  'scheduled',
  'decision',
  'enrolled',
  'waitlisted',
  'archived',
]);
export type FamilyWorkflowStatus = z.infer<typeof FamilyWorkflowStatusSchema>;

export const StudentStatusSchema = z.enum([
  'active',
  'inactive',
  'graduated',
  'withdrawn',
  'transferred',
]);
export type StudentStatus = z.infer<typeof StudentStatusSchema>;

export const StudentGenderSchema = z.enum(['male', 'female', 'other']);
export type StudentGender = z.infer<typeof StudentGenderSchema>;

export const ParentRelationSchema = z.enum([
  'father',
  'mother',
  'guardian',
  'step_parent',
  'grandparent',
  'other',
]);
export type ParentRelation = z.infer<typeof ParentRelationSchema>;

export const DocumentCategorySchema = z.enum([
  'transcript',
  'health_form',
  'recommendation',
  'birth_certificate',
  'immunization',
  'legal',
  'academic',
  'academic_support',
  'health_safety',
  'tuition_configuration',
  'tuition_contract',
  'other',
]);
export type DocumentCategory = z.infer<typeof DocumentCategorySchema>;

export const DocumentStatusSchema = z.enum([
  'pending',
  'draft',
  'sent',
  'verified',
  'under_review',
  'missing_signature',
  'rejected',
]);
export type DocumentStatus = z.infer<typeof DocumentStatusSchema>;

export const NoteCategorySchema = z.enum([
  'general',
  'health',
  'academic',
  'behavioral',
  'financial',
  'follow_up',
]);
export type NoteCategory = z.infer<typeof NoteCategorySchema>;

export const NoteVisibilitySchema = z.enum(['internal', 'shared']);
export type NoteVisibility = z.infer<typeof NoteVisibilitySchema>;

export const CommunicationChannelSchema = z.enum([
  'email',
  'sms',
  'in_app',
  'letter',
  'phone',
]);
export type CommunicationChannel = z.infer<typeof CommunicationChannelSchema>;

export const MessageDirectionSchema = z.enum(['inbound', 'outbound']);
export type MessageDirection = z.infer<typeof MessageDirectionSchema>;

export const CommunicationStatusSchema = z.enum([
  'draft',
  'queued',
  'sent',
  'delivered',
  'failed',
  'read',
]);
export type CommunicationStatus = z.infer<typeof CommunicationStatusSchema>;

export const LedgerEntryTypeSchema = z.enum([
  'tuition',
  'fee',
  'books_fee',
  'facilities_fee',
  'family_assessment_fee',
  'charge',
  'registration_fee',
  'security_fee',
  'fundraising_obligation',
  'multi_child_discount',
  'staff_discount',
  'chinuch_discount',
  'combined_discount',
  'late_fee',
  'payment',
  'refund',
  'reversal',
  'chargeback',
  'credit',
  'scholarship',
  'adjustment',
]);
export type LedgerEntryType = z.infer<typeof LedgerEntryTypeSchema>;

export const LedgerEntryStatusSchema = z.enum(['pending', 'posted', 'voided']);
export type LedgerEntryStatus = z.infer<typeof LedgerEntryStatusSchema>;

export const LedgerEntrySourceSchema = z.enum([
  'stripe_card',
  'stripe_bank_account',
  'stripe_refund',
  'stripe_chargeback',
  'manual_check',
  'manual_cash',
  'manual_ach',
  'manual_wire',
  'manual_bank_transfer',
  'manual_other',
  'system',
  'system_adjustment',
]);
export type LedgerEntrySource = z.infer<typeof LedgerEntrySourceSchema>;

export const BillingCategorySchema = z.enum([
  'tuition',
  'fees',
  'activities',
  'transportation',
  'food_service',
  'recurring',
  'other',
]);
export type BillingCategory = z.infer<typeof BillingCategorySchema>;

export const RecurringFeeBillingCategorySchema = z.enum([
  'activities',
  'transportation',
  'food_service',
  'other',
]);
export type RecurringFeeBillingCategory = z.infer<typeof RecurringFeeBillingCategorySchema>;

export const BulkChargeJobStatusSchema = z.enum([
  'processing',
  'complete',
  'failed',
]);
export type BulkChargeJobStatus = z.infer<typeof BulkChargeJobStatusSchema>;

export const FamilyPaymentMethodTypeSchema = z.enum([
  'card',
  'bank_account',
]);
export type FamilyPaymentMethodType = z.infer<typeof FamilyPaymentMethodTypeSchema>;

export const FamilyPaymentMethodStatusSchema = z.enum([
  'active',
  'inactive',
  'failed',
]);
export type FamilyPaymentMethodStatus = z.infer<typeof FamilyPaymentMethodStatusSchema>;

export const ActivityActionSchema = z.enum([
  'created',
  'updated',
  'deleted',
  'viewed',
  'exported',
]);
export type ActivityAction = z.infer<typeof ActivityActionSchema>;
